import {Outlet} from "react-router-dom";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const InvitationDetailsOutlet = () => <Outlet />;
